import React, { lazy, Suspense, useCallback, useMemo, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";

const CancelMarketBody = lazy(() => import("./CancelMarketBody"));
const CancelMarket = () => {

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    handleReopen: null,
  });

  return (
    <>
      {/* <Breadcrumb breadcrumb={[]} title={"Upload"} /> */}
      <SubHeading isAddBtn={false} />
      <Suspense fallback={<div>Loading...</div>}>
        <CancelMarketBody handleModal={setIsShow} />
      </Suspense>
      {/* Modal for Add/Edit Sport */}
      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="sm"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              handleFn: isShow.handleReopen,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default CancelMarket;
